export default __webpack_public_path__ + "static/media/sample_voice_english.ab73ce8a.wav";